import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import custom from '@/views/system/customManage/custom.vue';
import bulletinBoard from '@/views/system/customManage/bulletinBoard.vue';
import { addTemplate } from '@/views/system/customManage/request';
export default {
  components: {
    custom,
    bulletinBoard
  },
  props: ['id', 'permission'],
  watch: {
    permission: {
      handler(newArr) {
        this.$nextTick(() => {
          const permissions = this.permission.join(',');
          this.dashboardFrontPage = permissions.indexOf('customer.dashboardFrontPage') !== -1 || false;
          this.dashboardDataBoard = permissions.indexOf('customer.dashboardDataBoard') !== -1 || false;
          this.activeKey = this.dashboardFrontPage ? 1 : 2;
        });
      }
    },
    deep: true
  },
  data() {
    return {
      activeKey: -1,
      dashboardFrontPage: false,
      dashboardDataBoard: false,
      frontPage: {},
      bulletinBoardList: {},
      delList: []
    };
  },
  created() {
    this.$nextTick(() => {
      const permissions = this.permission.join(',');
      this.dashboardFrontPage = permissions.indexOf('customer.dashboardFrontPage') !== -1 || false;
      this.dashboardDataBoard = permissions.indexOf('customer.dashboardDataBoard') !== -1 || false;
      this.activeKey = this.dashboardFrontPage ? 1 : 2;
    });
  },
  methods: {
    delArrFun(val) {
      this.delList.push(val);
    },
    setObjFun(type, val) {
      this.bulletinBoardList[type] = val;
    },
    setItem() {
      this.frontPage = {
        panelList: this.$refs.customRef.panelList,
        previewList: this.$refs.customRef.previewList
      };
    },
    tabFun(val) {
      if (this.activeKey == 1) {
        this.frontPage = {
          panelList: this.$refs.customRef.panelList,
          previewList: this.$refs.customRef.previewList
        };
        console.log(this.frontPage, 222);
      }
      setTimeout(() => {
        this.activeKey = val;
      }, 400);
    },
    jumpFun() {
      if (this.dashboardDataBoard) {
        this.tabFun(2);
      } else {
        this.$message.success(this.$t('保存成功'));
        this.$router.go(-1);
      }
    },
    jumpFun2() {
      if (this.dashboardFrontPage) {
        this.$message.error(this.$t('需要完善首页数据'));
        this.tabFun(1);
      }
    },
    backFun() {
      this.$message.success(this.$t('保存成功'));
      this.$router.go(-1);
    },
    async onSubmit() {
      //首页数据
      let frontPageArr = [];
      if (this.dashboardFrontPage) {
        this.frontPage.previewList && Array.isArray(this.frontPage.previewList) && this.frontPage.previewList.map(item => {
          if (item && item.panelId) {
            frontPageArr.push(item);
          }
        });
        if (frontPageArr.length == 0) {
          return this.$message.error(this.$t('首页至少要配置一个'));
        }
      }
      let arr = [];
      if (this.dashboardDataBoard && this.$refs.bulletinBoardRef) {
        const bulletinBoardList = this.bulletinBoardList;
        //看板数据
        for (let i in bulletinBoardList) {
          for (let j = 0; j < bulletinBoardList[i].previewList.length; j++) {
            if (bulletinBoardList[i].previewList[j]) {
              bulletinBoardList[i].previewList[j].queryMethod = bulletinBoardList[i].queryMethod;
              bulletinBoardList[i].previewList[j].timeFrame = bulletinBoardList[i].timeFrame;
              arr.push(bulletinBoardList[i].previewList[j]);
            }
          }
        }
      }
      await addTemplate({
        data: frontPageArr.concat(arr),
        delList: this.delList
      });
      this.backFun();
    }
  }
};